// GENERATED by npm run generate-graphql-operations
const UpdateStationDetails = 'mutation UpdateStationDetailsWeb($stationId: String!, $name: String!, $description: String!, $enableArtistMessages: Boolean) {   setStationDetails(stationId: $stationId, name: $name, description: $description, enableArtistMessages: $enableArtistMessages) {     status   } } ';
export default UpdateStationDetails;
